import { createApi } from "@reduxjs/toolkit/query/react";
import { transformErrorResponse, transformSuccessResponse } from "../../../../utils/API/responseMiddleware";
import {  defaultBaseQuery } from "../../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../../utils/API/requestMiddleware";

const DropdownManagementApi = createApi({
    reducerPath: 'DropdownManagementApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getDropdownRecordList: builder.mutation({
            query: () => ({
                url: '/FieldManagement/GetDropdownRecordList',
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getDropdownDatabyId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/FieldManagement/GetDropdownDatabyId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditDropdownData: builder.mutation({
            query: (details) => ({
                url: '/FieldManagement/AddEditDropdownData',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteDropdowndata: builder.mutation({
            query: (details) => ({
                url: '/FieldManagement/Deletedropdowndata',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
useGetDropdownRecordListMutation,
useLazyGetDropdownDatabyIdQuery,
useAddEditDropdownDataMutation,
useDeleteDropdowndataMutation
} = DropdownManagementApi;

export default DropdownManagementApi;